import React, {useState, useEffect, useCallback, useRef} from 'react';

export function Progress({all = 0, done = 0}) {
  const [progress, setProgress] = useState(all > 0 ? done / all * 100 : 0);
  const refBar = useRef();

  const changeSticky = useCallback(() => {
    if (!refBar || !refBar.current) {
      return;
    }
    if (window.scrollY >= 50) {
      refBar.current.style.opacity = 1;
    } else {
      refBar.current.style.opacity = 0;
    }
  }, [refBar]);

  useEffect(() => {
    changeSticky();
    document.addEventListener('scroll', changeSticky);
    return () => document.removeEventListener('scroll', changeSticky);
  }, [changeSticky]);

  useEffect(() => {
    setProgress(all > 0 ? done / all * 100 : 0);
  }, [all, done]);

  return <div className="progress" ref={refBar}>
    <div className="progress__container">
      <p className="progress__text"><span className="progress__text-amount">{done}</span> из <span
        className="progress__text-length">{all}</span> ответов</p>
      <div className="progress__bar">
        <div className="progress__bar-line" data-width={progress} style={{width: progress + '%'}}></div>
      </div>
    </div>
  </div>;
}
